import { Back } from "../../../ui/icons";
import InputField from "./InputField";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { getUser, patchPhotoUser } from "../../../store/authSlice";
import { useTranslation } from 'react-i18next';

const PersonalData = ({ setActiveTab, activeTab, isMobile }) => {
    const { t } = useTranslation();
    const { user } = useSelector((store) => store.auth);
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: ""
    });
    const fileInputRef = useRef(null);
    const dispatch = useDispatch();

    const handleClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = (e) => {
        const file = Array.from(e.target.files)[0];
        dispatch(patchPhotoUser(file));
    };

    useEffect(() => {
        setFormData({ first_name: user?.first_name, last_name: user?.last_name });
    }, [user]);

    return (
        <>
            <div className="flex items-center gap-5 pb-2 pl-5 shadow-md sm:shadow-none">
                {activeTab && isMobile && (
                    <button
                        className="cursor-pointer"
                        onClick={() => setActiveTab(null)}
                        aria-label={t('personal_data.back_button')}
                    >
                        <Back />
                    </button>
                )}
                <p className='font-normal text-[18px]'>{t('personal_data.title')}</p>
            </div>
            <div className="px-5 pt-5">
                <div className='lg:flex sm:flex gap-10 items-center'>
                    <img 
                        src={user?.photo ? user?.photo : "./images/Profile/beg.png"} 
                        className='w-[50%] sm:w-[12%] m-auto object-cover' 
                        alt={t('personal_data.profile_image_alt')} 
                        style={{ aspectRatio: '1 / 1', borderRadius: "50%" }}
                    />

                    <div className='flex gap-2 pt-2 sm:gap-5 text-[#FFF] w-full'>
                        <button
                            className="py-2 rounded-xl sm:rounded-2xl font-semibold text-base w-[50%] sm:w-[30%] bg-[#8C1C1C]"
                            onClick={handleClick}
                        >
                            {t('personal_data.add_photo_button')}
                        </button>
                        <input
                            type="file"
                            ref={fileInputRef}
                            className="hidden"
                            onChange={handleFileChange}
                            accept="image/*"
                        />
                        <button
                            className='py-2 rounded-xl sm:rounded-2xl font-semibold text-base w-[50%] sm:w-[30%] bg-[#BA7373]'
                        >
                            {t('personal_data.delete_photo_button')}
                        </button>
                    </div>
                </div>
                <div className='w-full lg-flex sm:flex gap-5 pt-5'>
                    <InputField 
                        label={t('personal_data.surname_label')} 
                        value={formData?.first_name} 
                        width={"100%"}
                    />
                    <InputField 
                        label={t('personal_data.name_label')} 
                        value={formData?.last_name} 
                        width={"100%"}
                    />
                </div>
                <h2 className="pt-5 pb-2">{t('personal_data.payment_section')}</h2>
                <div className='flex gap-2 sm:gap-5 text-[#FFF] w-full'>
                    <button className='py-2 rounded-xl sm:rounded-2xl font-semibold text-base w-[50%] sm:w-[30%] bg-[#BA7373]'>
                        VISA
                    </button>
                </div>
            </div>
            <button
                className='py-2 block sm:hidden rounded-xl sm:rounded-2xl font-semibold text-base w-[90%] sm:w-[30%] bg-[#402D1D] text-[#FFF]'
                style={{ position: 'absolute', bottom: '30px', left: "50%", transform: "translateX(-50%)" }}
            >
                {t('personal_data.save_button')}
            </button>
        </>
    );
};

export default PersonalData;